import { DEVICE, TYPOGRAPHY } from '@net0-calc/common/assets/styles';
import { FC } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const EventNameInput: FC = () => {
  const { t } = useTranslation();

  return (
    <Root>
      <StyledLabel>{t('personal.pages.tripDuration.form.field.eventName')}</StyledLabel>
      <InputWrap>
        <Field name="eventName">{({ input }: FieldRenderProps<any>) => <StyledInput {...input} />}</Field>
      </InputWrap>
    </Root>
  );
};

const Root = styled.div`
  width: 100%;
  margin-top: 0;

  @media ${DEVICE.laptop} {
    margin-top: 8px;
  }
`;

const StyledInput = styled.input`
  ${TYPOGRAPHY.bodyRegular16}
  width: 80%;
  color: var(--color6);
  outline: none;
`;

const InputWrap = styled.div`
  position: relative;
  width: 100%;
  height: 64px;
  padding: 18px;

  border-radius: 15px;
  border: 2px solid var(--color10);

  background-color: var(--color5);

  cursor: text;
  transition: all 0.2s;
  margin-bottom: 24px;

  @media ${DEVICE.laptop} {
    margin-bottom: 8px;
  }

  &:focus-within {
    border: 2px solid var(--color2);
  }
`;

const StyledLabel = styled.label`
  ${TYPOGRAPHY.captionRegular14};
  display: block;
  margin-bottom: 8px;
  color: var(--color9);
`;
